import { axios } from '@/api/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  PartyCreateModel,
  PartyUpdateModel,
  PartyUpdateSchema,
} from './mutation.schema'

export async function createParty(data: PartyCreateModel): Promise<void> {
  await axios.post('/api/masterdata/parties', data)
}

export const useCreatePartyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createParty,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parties'] })
    },
  })
}

export async function updateParty(data: PartyUpdateModel): Promise<void> {
  const patch = PartyUpdateSchema.parse(data)
  await axios.put(`/api/masterdata/parties/${data.id}`, patch)
}

export const useUpdatePartyMutation = (id: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['parties', 'update', id],
    mutationFn: updateParty,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parties'] })
    },
  })
}

// =================  delete party =================

export const useDeletePartyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => axios.delete(`/api/masterdata/parties/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parties'] })
    },
  })
}
